import { ROLES, type Role } from './roles';

const { SUPPORT, ADMIN, MEMBER } = ROLES;

export const PERMISSIONS = {
  // Portfolios
  'portfolio.create': [SUPPORT, ADMIN, MEMBER],
  'portfolio.moreMenu': [SUPPORT, ADMIN],
  'portfolio.settings.view': [SUPPORT, ADMIN, MEMBER],
  'portfolio.settings.editRestricted': [SUPPORT, ADMIN],

  // Optimization
  'optimization.launch': [SUPPORT, ADMIN],
  'optimization.apply': [SUPPORT, ADMIN, MEMBER],
  'optimization.edit': [SUPPORT, ADMIN],

  // Budget & Targets
  'budget.edit': [SUPPORT, ADMIN, MEMBER],
  'target.edit': [SUPPORT, ADMIN, MEMBER],

  // Content tab (portfolio contents — manual add + bulk edit)
  'content.edit': [SUPPORT, ADMIN, MEMBER],
  'content.editMetrics': [SUPPORT, ADMIN],
  'content.remove': [SUPPORT, ADMIN],

  // Team settings
  'team.settings.view': [SUPPORT, ADMIN, MEMBER],
  'team.member.changeRole': [SUPPORT, ADMIN, MEMBER],
  'team.member.assignSupport': [SUPPORT],
  // Backend rejects Member→Read-Only role changes (verified via QA: "An internal
  // error has occurred…"). Only Support can assign the Read-Only role.
  'team.member.assignReadOnly': [SUPPORT, ADMIN],
  'team.featureFlags.view': [SUPPORT],
  // Settings → Parameters tab. The team's `calculated_metric` flag is checked separately in Settings.tsx.
  'team.parameters.view': [SUPPORT, ADMIN],
  'team.fetchMeasurements': [SUPPORT, ADMIN],
} as const satisfies Record<string, readonly Role[]>;

export type Permission = keyof typeof PERMISSIONS;
